import React, { Component } from "react";
import { Switch, Redirect, Route, withRouter } from "react-router-dom";
import MyNav from "./components/myNav2";
import Loading from "./components/loading";
import styleObj from "./App.module.scss";
import { getData } from "./assets/js/getData";
import Page from "./pages/page2";
import router from "./router";

const routes = router.map((item) => {
  item.component = () => (
    <Page meta={item.meta} routeName={item.routeName} routeCity={item.label} />
  );
  return item;
});

class App extends Component {
  constructor() {
    super();
    this.state = {
      init: false,
      background: "#100E1C",
    };
  }
  render() {
    let minH = window.innerHeight;
    let { init, background } = this.state;
    return (
      <div
        className={styleObj["App"]}
        style={{ minHeight: `${minH}px`, background }}
      >
        {init ? (
          <>
            <MyNav />
            <div className={styleObj["main"]}>
              <Switch>
                {routes.map((item) => (
                  <Route
                    exact
                    key={item.path}
                    path={item.path}
                    component={item.component}
                  ></Route>
                ))}
                <Redirect to="/" />
              </Switch>
            </div>
          </>
        ) : (
          <Loading />
        )}
      </div>
    );
  }
  onInit = (route) => {
    console.log("route", route);
    if (route.meta?.is2021) {
      this.setState({
        background: `#981d24 url(${require("./assets/imgs/background2021.png")})`,
      });
    } else {
      this.setState({
        background: "#100E1C",
      });
    }
  };
  current_route = (path) => {
    const [route] = router.filter((route) => route.path === path);
    return route;
  };
  componentDidMount() {
    this.props.history.listen(({ pathname }) => {
      const route = this.current_route(pathname);
      this.onInit(route);
    });
    const { location } = this.props;
    const route = this.current_route(location.pathname);
    this.onInit(route);
    getData().then((message) => {
      this.setState({
        init: true,
      });
    });
  }
}

export default withRouter(App);
